import { createApp } from '@backstage/frontend-defaults';

// Plugin features
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import catalogImportPlugin from '@backstage/plugin-catalog-import/alpha';
import scaffolderPlugin from '@backstage/plugin-scaffolder/alpha';
import techdocsPlugin from '@backstage/plugin-techdocs/alpha';
import { techDocsMermaidAddonModule } from 'backstage-plugin-techdocs-addon-mermaid';
import searchPlugin from '@backstage/plugin-search/alpha';
import apiDocsPlugin from '@backstage/plugin-api-docs/alpha';
import userSettingsPlugin from '@backstage/plugin-user-settings/alpha';
import orgPlugin from '@backstage/plugin-org/alpha';
import homePlugin from '@backstage/plugin-home/alpha';

// Tech Radar excluded: @backstage-community/plugin-tech-radar's compat layer
// depends on removed frontend-plugin-api exports (componentsApiRef, coreComponentRefs).
// Re-add once the community plugin is updated for frontend-plugin-api >=0.14.0.

// Custom modules
import { themeModule } from './core/theme';
import { signInModule } from './features/auth';
import { apisModule, ariaRouterModule } from './core/config';
import { translationModule } from './core/i18n';
import { rootLayoutModule, pageLayoutModule } from './core/layouts';
import { swappableComponentsModule } from './shared/components';
import { catalogPagesModule } from './features/catalog';
import { docsPagesModule } from './features/docs';
import { createPagesModule } from './features/create';
import { settingsPagesModule } from './features/settings';
import { searchPagesModule } from './features/search';
import { qualityPlugin } from './features/quality';
import { homeModule } from './features/home';

const app = createApp({
  features: [
    catalogPlugin,
    catalogImportPlugin,
    scaffolderPlugin,
    techdocsPlugin,
    techDocsMermaidAddonModule,
    searchPlugin,
    apiDocsPlugin,
    userSettingsPlugin,
    orgPlugin,
    homePlugin,
    // Custom modules
    themeModule,
    signInModule,
    apisModule,
    ariaRouterModule,
    translationModule,
    rootLayoutModule,
    pageLayoutModule,
    swappableComponentsModule,
    catalogPagesModule,
    docsPagesModule,
    createPagesModule,
    settingsPagesModule,
    searchPagesModule,
    qualityPlugin,
    homeModule,
  ],
});

export default app.createRoot();
